module.exports = __webpack_public_path__ + "static/media/dk.d046fb5b.svg";